<template>
    <div class="row" v-bind:class="{ 'has-danger' : error !== null, 'form-group': !noFormGroup }">
        <label :class="labelClasses" class="form-control-label  col-form-label" :for="name + '_amount'">{{ labelComputed }}</label>
        <div :class="inputHolderClasses">
            <div class="row">
                <div class="col-6">
                    <input class="form-control" type="number" step="0.01" min="0" :name="name + '_amount'" :id="name + '_amount'" v-model="amount" :max="amountMax"/>
                </div>
                <div class="col-6">
                    <multi-select  :name="name + '_type'" :id="name + '_type'" :options="type_options" v-model="type"
                                   value="€" :searchable="false" label="name"
                                   :selectedLabel="uLang('app.select')" :selectLabel="uLang('app.press_enter_to_select')"
                                   :deselectLabel="uLang('app.press_enter_to_remove')" :placeholder="uLang('app.select_an_option')"/>
                </div>
            </div>
            <span class="help-block form-control-feedback" v-if="error != null" v-text="error"></span>
        </div>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect'
    import ElementMixin from '~/mixins/element'

    export default {
        name: 'price-with-type',

        mixins: [ElementMixin],

        components: {
            'multi-select': MultiSelect,
        },

        props: {
            value: {
                type: Object,
                required: false,
                default: () => {
                    return {
                        amount: null,
                        type: null,
                    }
                }
            },
            noFormGroup: {
                type: Boolean,
                required: false,
                default: false,
            },
            labelClasses: {
                type: String,
                required: false,
                default: 'col-md-3 col-xl-2 col-sm-12',
            },
            inputHolderClasses: {
                type: String,
                required: false,
                default: 'col-md-9 col-xl-10 col-sm-12'
            },
        },

        data() {
            return {
                amount: null,
                type: null,
                type_options: [
                    {
                        name: '%',
                        value: '%',
                    },
                    {
                        name: '€',
                        value: '€',
                    },
                ],
            };
        },

        created() {
            this.amount = this.value.amount;
            this.type = this.value.type;


            this.type = this.type_options.find((option) => {
                return option.value == this.value.type;
            }) || null;

        },

        computed: {
            amountMax() {
                return this.type && this.type.value === '%' ? 100 : null;
            },
            compoundProperty() {
                let a = this.amount;
                let t = this.type;

                return Date.now();
            },
        },

        watch: {
            compoundProperty() {
                this.$emit('input', { amount: this.amount, type: this.type.value});
            }
        }
    };
</script>
